import { render, staticRenderFns } from "./keyWordReportList.vue?vue&type=template&id=8facf0ac&scoped=true"
import script from "./keyWordReportList.vue?vue&type=script&lang=js"
export * from "./keyWordReportList.vue?vue&type=script&lang=js"
import style0 from "./keyWordReportList.vue?vue&type=style&index=0&id=8facf0ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8facf0ac",
  null
  
)

export default component.exports